import { ActionsButtons } from "./ActionsButtons";

const Assistant = ({
  finalSets,
  editDayMode,
  editable,
  exerciseId,
  handleInput,
  addTempSet,
  removeSet,
  addingSet,
  onAddSet,
  onSubmitSet,
  onDiscardSet,
}) => (
  <div
    className={`assistant-container${
      editDayMode && !editable ? " not-editable" : ""
    }`}
  >
    {finalSets &&
      finalSets.map((set, idx) => {
        return (
          <div className="set-row" key={idx}>
            {editDayMode && editable ? (
              <>
                <input
                  type="text"
                  id={`sets-${exerciseId}-${idx}`}
                  value={set.freeform}
                  onChange={(evt) =>
                    handleInput({
                      value: evt.target.value,
                      field: "freeform",
                      exerciseId,
                      setIdx: idx,
                    })
                  }
                />
                <ActionsButtons
                  addingSet={addingSet}
                  onAddSet={() => {
                    addTempSet({
                      exerciseId,
                      pos: idx,
                      freeForm: true,
                    });
                    // Setting the addingSet index to the next row so the new set row
                    // will have the actions buttons that appear below in the code
                    onAddSet(++idx);
                  }}
                  addSetImgSize={24}
                  onRemoveSet={() => removeSet(exerciseId, idx)}
                  removeSetImgSize={18}
                  onSubmitSet={onSubmitSet}
                  onDiscardSet={() => {
                    removeSet(exerciseId, idx);
                    onDiscardSet();
                  }}
                  setIdx={idx}
                />
              </>
            ) : (
              set.freeform
            )}
          </div>
        );
      })}
  </div>
);

export default Assistant;
